import React from 'react';
import PropTypes from 'prop-types';
import api from 'api';
import Component from 'BaseComponent';
import { notice, alert } from 'ducks/notifications';
import { reduxForm } from 'redux-form';
import convertToFormErrors from 'utils/convertToFormErrors';
import Field from 'form/Field';
import Form from 'form/Form';
import validators from 'utils/validators';
import generateFormValidation from 'utils/generateFormValidation';
import SubmitButton from 'form/SubmitButton';
import { query } from 'redux-bees';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import CountrySelect from 'components/CountrySelect';
import queryString from 'query-string';

@withRouter

@query('billingProfile', api.getBillingProfile)

@connect((state, props) => ({
  initialValues: props.billingProfile && props.billingProfile.attributes,
}))


@reduxForm({
  form: 'EditBillingInfo',
  validate: generateFormValidation({
    email: [validators.required()],
  }),
  onSubmit(values, dispatch, props) {
    const parsedQuery = queryString.parse(props.location.search);

    return dispatch(api.updateBillingInfo(
      {
        data: {
          type: 'billingProfile',
          attributes: { ...values },
        },
      },
    ))
    .then(() => {
      props.history.push(parsedQuery.returnTo || '/account');
      dispatch(notice('BillingInfo.success'));
    })
    .catch((response) => {
      dispatch(alert('BillingInfo.error'));
      return Promise.reject(convertToFormErrors(response));
    });
  },
})

export default class EditBillingInfo extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }

  renderLoading() {
    return <span>Loading..</span>;
  }

  render() {
    const { handleSubmit, submitting, error, dirty } = this.props;
    return (
      <Form error={error} onSubmit={handleSubmit}>
        <div className="grid space--bottom-2">
          <div className="grid__item width-6-12">
            <Field label="CreateBillingProfile.firstName" name="firstName">
              <input type="text" required />
            </Field>
          </div>
          <div className="grid__item width-6-12">
            <Field label="CreateBillingProfile.lastName" name="lastName">
              <input type="text" required />
            </Field>
          </div>
        </div>
        <Field label="CreateBillingProfile.email" name="email">
          <input type="text" required />
        </Field>
        <Field label="CreateBillingProfile.country" name="country">
          <CountrySelect required />
        </Field>
        <div className="grid space--bottom-2">
          <div className="grid__item width-4-12">
            <Field label="CreateBillingProfile.city" name="city">
              <input type="text" />
            </Field>
          </div>
          <div className="grid__item width-4-12">
            <Field label="CreateBillingProfile.state" name="state">
              <input type="text" />
            </Field>
          </div>
          <div className="grid__item width-4-12">
            <Field label="CreateBillingProfile.zip" name="zip">
              <input type="text" />
            </Field>
          </div>
        </div>
        <Field label="CreateBillingProfile.addressLine" name="addressLine">
          <input type="text" />
        </Field>
        <div className="grid space--bottom-2">
          <div className="grid__item width-6-12">
            <Field label="CreateBillingProfile.company" name="company">
              <input type="text" />
            </Field>
          </div>
          <div className="grid__item width-6-12">
            <Field label="CreateBillingProfile.vatNumber" name="vatNumber">
              <input type="text" />
            </Field>
          </div>
        </div>
        <SubmitButton
          dirty={dirty}
          className="button button--primary button--expand button--huge"
          submitting={submitting}
          label="UpdateBillingProfile.submit"
        />
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/EditBillingInfo.jsx